module.exports = __webpack_public_path__ + "img/cw.c7547a00.svg";